<template>
  <div class="panel type-r">
    <div class="panel-content">
      <div class="tabs">
        <form class="params" method="post" enctype="multipart/form-data">
          <div class="tab tab-4 tab-active" id="tab-4">
            <h6 class="subtitle-type-r">{{ $t("competition.scheme") }}</h6>
            <div class="section section-type-r">
              <div class="settings">
                <div class="setting setting-type" id="type">
                  <!-- <label for="type">
										<p class="setting-name">Tip schema</p>
										<div class="setting-option">
											<select :disabled="!isVisible" id="field-type" name="type" v-model="type">
												<option value="circuit">{{ $t('competition.circuit') }}</option>
												<option value="group">{{ $t('competition.groups') }}</option>
											</select>
										</div>
									</label> -->
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <p class="setting-name">
                      {{ $t("competition.choose_format") }}
                    </p>
                    <RadioGroup v-model="type" class="d-flex">
                      <Radio
                        :disabled="formatChangeCondition()"
                        label="group"
                        class="ttypes-radio-style"
                        >{{ $t("competition.groups") }}</Radio
                      >
                      <Radio
                        :disabled="formatChangeCondition()"
                        label="circuit"
                        class="ttypes-radio-style"
                        >{{ $t("competition.circuit") }}</Radio
                      >
                    </RadioGroup>
                  </div>
                </div>

                <div
                  v-if="type === 'circuit'"
                  id="iterations"
                  class="setting setting-iterations d-flex justify-content-between align-items-center"
                >
                  <p class="setting-name">
                    {{ $t("competition.iteration") }}
                    <span class="info-hover">
                      <i>i</i>
                      <span class="info">
                        {{ $t("competition.iteration_info") }}
                      </span>
                    </span>
                  </p>
                  <div class="selector-items">
                    <RadioGroup v-model="spec" class="d-flex flex-wrap">
                      <Radio
                        :disabled="formatChangeCondition()"
                        label="oneway"
                        class="ttypes-radio-style"
                        >{{ $t("competition.circuit1") }}</Radio
                      >
                      <Radio
                        :disabled="formatChangeCondition()"
                        label="twoway"
                        class="ttypes-radio-style"
                        >{{ $t("competition.circuit2") }}</Radio
                      >
                    </RadioGroup>
                  </div>
                </div>
                <div
                  v-if="type === 'circuit'"
                  id="iterations"
                  class="setting setting-iterations d-flex justify-content-between align-items-center"
                >
                  <p class="setting-name">
                    {{ $t("competition.calc") }}
                    <span class="info-hover1 info-hover">
                      <i>i</i>
                      <span class="info">
                        {{ $t("competition.calc_description") }}
                      </span>
                    </span>
                  </p>
                  <div class="selector-items">
                    <RadioGroup v-model="countBy" class="d-flex flex-nowrap">
                      <Radio
                        :disabled="formatChangeCondition()"
                        label="points"
                        class="ttypes-radio-style"
                      >
                        {{ $t("competition.by_points") }}
                      </Radio>
                      <Radio
                        :disabled="formatChangeCondition()"
                        label="places"
                        class="ttypes-radio-style"
                      >
                        {{ $t("competition.by_places") }}
                      </Radio>
                    </RadioGroup>
                  </div>
                </div>
                <div
                  v-if="type === 'group'"
                  class="setting setting-select setting-group_num"
                  id="group_num"
                >
                  <label for="group_num">
                    <p class="setting-name">
                      {{ $t("competition.group_qty") }}
                      <span class="info-hover">
                        <i>i</i>
                        <span class="info">
                          {{ $t("competition.group_num_info") }}
                        </span>
                      </span>
                    </p>
                    <div class="setting-option">
                      <select
                        :disabled="formatChangeCondition()"
                        id="field-group_num"
                        name="group_num"
                        v-model="qty"
                        style="width:60px"
                      >
                        <!-- <option value="1">1</option> -->
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                  </label>
                </div>
                <div
                  v-if="type === 'group'"
                  class="setting setting-select setting-group_adv"
                  id="group_adv"
                >
                  <label for="group_adv">
                    <p class="setting-name">
                      {{ $t("competition.playoff_qty") }}
                      <span class="info-hover">
                        <i>i</i>
                        <span class="info">
                          {{ $t("competition.playoff_info") }}
                        </span>
                      </span>
                    </p>
                    <div class="setting-option">
                      <select
                        :disabled="formatChangeCondition()"
                        id="field-group_adv"
                        v-model="sizeOfBrackets"
                        name="group_adv"
                        style="width:60px"
                      >
                        <option
                          v-for="(team, i) in teams"
                          v-if="
                            parseInt(qty) === 3
                              ? i === 3
                              : i >= parseInt(qty) - 1 &&
                                (i + 1) % parseInt(qty) === 0 &&
                                (i + 1) % 2 === 0 &&
                                i <= 8
                          "
                          :value="i + 1"
                        >
                          {{ i + 1 }}
                        </option>
                      </select>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <h6 class="subtitle-type-r">{{ $t("menu.teams-table") }}</h6>
            <!-- <Spin v-if="loading" fix>
							<Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
							<div>{{ $t("global.loading") }}</div>
						</Spin> -->
            <div v-if="type === 'group'" class="section section-participants">
              <div class="settings">
                <div
                  class="participant-placeholder"
                  id="participant-placeholder"
                ></div>
                <div class="participants ui-sortable">
                  <template v-for="(group, i) in groups">
                    <div class="group-name group-name-list">
                      <span>{{ $t("competition.group") }}</span>
                      {{ getLetter(i + 1) }}
                    </div>
                    <draggable
                      v-if="isDraggable"
                      :list="group"
                      @change="() => updateLocalGroups()"
                      group="teams"
                    >
                      <div
                        v-for="team in group"
                        :key="team._id"
                        class="participant d-flex"
                        id="participant-6"
                      >
                        <div
                          class="participant-handle ui-sortable-handle"
                        ></div>
                        <div class="participant-seed ui-sortable-handle">
                          {{ i + 1 }}
                        </div>
                        <div class="participant-name d-flex" style="width:100%">
                          <input
                            type="text"
                            name="participant-6"
                            maxlength="35"
                            :value="team.name"
                          />
                          <!-- <span v-if="team.statistics">{{
                            team.statistics.stages[currentStageIndex].points
                          }}</span> -->
                        </div>
                      </div>
                    </draggable>
                    <div v-else class="participant d-flex" id="participant-6">
                      <div class="type-r brackets-sidebar-team-style w-100">
                        <div
                          class="type-r section standings"
                          style="display: block;"
                        >
                          <div class="type-r">
                            <div class="standing-labels">
                              <span style="width: 7%;">#</span>
                              <span style="width: 78%;">{{
                                $t("competition.team_name")
                              }}</span>
                              <span
                                style="width: 15%; padding-right: 10px;"
                                class="text-center"
                                >P</span
                              >
                            </div>
                            <div v-for="(team, j) in group" class="standing">
                              <div class="r" style="width: 7%;">
                                {{ j + 1 }}
                              </div>
                              <div class="n" style="width: 78%;">
                                <Tooltip
                                  :content="team.name"
                                  placement="top-start"
                                  class="w-100"
                                >
                                  <span
                                    class="text-overflow-style single-groups-clamp-text w-100"
                                  >
                                    {{ team.name }}
                                  </span>
                                </Tooltip>
                              </div>
                              <div class="w text-center" style="width: 15%;">
                                <span v-if="team.statistics">{{
                                  team.statistics.stages[currentStageIndex]
                                    .points
                                }}</span>
                                <span v-else>0</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div v-if="isDraggable" class="add-buttons">
                  <Button
                    @click="refreshMatchesInGroups"
                    :disabled="disabledCondition()"
                    type="info"
                    long
                    class="shuffle-button-style"
                  >
                    <!-- <div class="icon icon-shuffle"></div> -->
                    {{ $t("competition.save_groups") }}
                  </Button>
                </div>
              </div>
            </div>
            <div class="type-r brackets-sidebar-team-style">
              <div
                @click="statsModal = true"
                class="type-r section standings"
                style="display: block;"
              >
                <div class="type-r">
                  <div class="standing-labels">
                    <span style="width: 7%;">#</span>
                    <span style="width: 42%;">{{
                      $t("competition.team_name")
                    }}</span>
                    <span
                      style="width: 15%; padding-left: 10px;"
                      class="text-center"
                      >P</span
                    >
                    <span style="width: 20%;" class="text-center">E</span>
                    <span style="width: 13%;" class="text-center">{{
                      $t("competition.short_diff")
                    }}</span>
                  </div>
                  <div v-for="(team, index) in listedTeams" class="standing">
                    <div class="r" style="width: 7%;">{{ index + 1 }}</div>
                    <div class="n" style="width: 42%;">
                      <Tooltip
                        :content="team.name"
                        placement="top-start"
                        class="w-100"
                      >
                        <span
                          class="text-overflow-style single-groups-clamp-text w-100"
                        >
                          {{ team.name }}
                        </span>
                      </Tooltip>
                    </div>
                    <div class="w text-center" style="width: 15%;">
                      <span v-if="team.statistics">
                        {{
                          countBy === "places"
                            ? listedTeams.length - index
                            : team.statistics.stages[currentStageIndex].points
                        }}
                      </span>
                      <span v-else>0</span>
                    </div>
                    <div class="l text-center" style="width: 20%;">
                      <span v-if="team.statistics">
                        {{ team.statistics.stages[currentStageIndex].scored }} -
                        {{ team.statistics.stages[currentStageIndex].conceded }}
                      </span>
                      <span v-else>0</span>
                    </div>
                    <div class="diff text-right" style="width: 13%;">
                      <span v-if="team.statistics">
                        <b>
                          ({{
                            team.statistics.stages[currentStageIndex].scored -
                              team.statistics.stages[currentStageIndex]
                                .conceded
                          }})
                        </b>
                      </span>
                      <span v-else>0</span>
                    </div>
                  </div>
                </div>
              </div>
              <Button long type="info" @click="statsModal = true">
                {{ $t("competition.see_full_table") }}
              </Button>
              <!-- <div
								v-if="competition && showFinalStandings && competition.stages.find((stage) => stage.isCurrent && stage.isChosen)"
								class="mt-5">
								<Button
									v-if="competition.stages.findIndex((stage) => stage.isChosen ? stage.isChosen : stage.isCurrent) === competition.stages.length - 1 && !competition.isCompleted"
									type="info" @click="() => finishCompetition()" long size="large">
									<b>{{ $t('competition.finish') }}</b>
								</Button>
								<Button
									v-else-if="competition.stages.findIndex((stage) => stage.isChosen ? stage.isChosen : stage.isCurrent) !== competition.stages.length - 1 && !nextStageIsAvailable"
									type="info" @click="() => detectCurrentStage()" long size="large">
									<b>{{ $t('competition.next') }}</b>
								</Button>
							</div> -->
            </div>
          </div>
        </form>
      </div>
    </div>
    <StatsModal v-if="statsModal" @close="() => closeStatsModal()" />
  </div>
</template>
<script>
import bracketsMixin from "./bracketsMixin";
import StatsModal from "./StatsModal.vue";
import draggable from "vuedraggable";

export default {
  name: "BracketSidebar",
  components: { StatsModal, draggable },
  data() {
    return bracketsMixin;
  },
  methods: {
    formatChangeCondition() {
      if (this.visibilityBetweenStages === true) {
        return false;
      } else {
        return this.isVisible || !this.partAccess;
      }
    },
    disabledCondition() {
      let condition = this.competition.formats.find(
        format =>
          format.category._id === this.$route.params.cat &&
          format.stage === localStorage.getItem("chosenStage")
      );
      let typeEq = this.type === condition.format_type;
      let specEq = this.spec === condition.spec;
      let sizeEq = this.sizeOfBrackets === condition.sizeOfBrackets;
      let qtyEq = this.qty === condition.group_qty;
      let countEq = this.countBy === condition.count;
      if (this.type === "group" && typeEq && sizeEq && qtyEq) {
        return false;
      } else if (this.type === "circuit" && typeEq && specEq && countEq) {
        return false;
      }
      return true;
    },
    closeStatsModal() {
      this.statsModal = false;
      this.listedTeams = this.sortByStageStats(
        JSON.parse(JSON.stringify([...this.teams])),
        true
      );
      console.log({ LISTEDTEAMS: this.listedTeams });
    },
    async refreshMatchesInGroups() {
      this.$dialog
        .confirm(this.$t("global.confirmSaveGroups"), {
          okText: this.$t("global.yes"),
          cancelText: this.$t("global.no"),
          html: true,
          customClass: "mahnung-confirm"
        })
        .then(async _dialog => {
          await this.updateTeamsGroups();
          await this.getCurrentTeams();
          this.formGroups();
          this.$nextTick(async () => {
            await this.generateRoundRobinSchedule();
          });
          // if (this.currentStageIndex !== 0) {
          //   await this.addMoreMatches();
          // }
          this.forceRerender();
          if (this.sizeOfBrackets) this.canSave = true;
          this.$emit("close", 0);
        })
        .catch(error => {
          console.log(error);
        });
    },
    checkGroupQty(i) {
      if (parseInt(this.sizeOfBrackets) % parseInt(this.qty) === 0) {
        return i;
      } else if (i >= parseInt(this.qty)) {
        return i;
      } else if (i <= 8) {
        return i;
      }
      return null;
    }
  },

  async created() {
    this.loading = true;
    this.statsModal = false;
    await this.getCurrentCompetition(true);
    if (
      this.competition.stages.filter(
        stage => stage.category === this.$route.params.cat
      ).length &&
      this.competition.stages
        .filter(stage => stage.category === this.$route.params.cat)
        .findIndex(stage => stage.isCurrent) !==
        this.competition.stages.filter(
          stage => stage.category === this.$route.params.cat
        ).length -
          1
    ) {
      await this.checkStageAvailability([
        this.competition.stages.filter(
          stage => stage.category === this.$route.params.cat
        )[
          this.competition.stages
            .filter(stage => stage.category === this.$route.params.cat)
            .findIndex(stage => stage.isChosen) + 1
        ]
      ]);
    }

    this.getCategory();
    if (!this.type) {
      this.type = "circuit";
    }
    if (!this.qty) {
      this.qty = 2;
    }
    if (!this.sizeOfBrackets) {
      this.sizeOfBrackets = 2;
    }
    console.log(this.$user);
    if (this.$user.data.role.includes("manager")) {
      this.partAccess = true;
    }
    this.loading = false;
  },
  watch: {
    type(value) {
      console.log({ UPPER: value });
      if (this.isVisible || this.visibilityBetweenStages) {
        if (!value) {
          this.type = "group";
        } else {
          this.type = value;
        }
        if (value === "group" && !this.qty && !this.sizeOfBrackets) {
          this.qty = 2;
          this.sizeOfBrackets = 2;
        } else if (value === "circuit" && !this.spec && !this.countBy) {
          this.spec = "oneway";
          this.countBy = "points";
        }
        this.matches = [];
        this.rounds = [];
      }
    },
    async spec(value) {
      console.log({ LOWER: value });
      if (this.isVisible || this.visibilityBetweenStages) {
        this.spec = value;
        this.countBy = "points";
        this.matches = [];
        this.rounds = [];
        if (this.type === "circuit") {
          console.log("HERHEHREHRHERHEHR");
          await this.getCurrentTeams();
          await this.CircuitGenerate();
        }
      }
    },
    async qty(value) {
      if (this.isVisible || this.visibilityBetweenStages) {
        this.matches = [];
        this.rounds = [];
        if (this.type === "group") {
          await this.getCurrentTeams();
          this.formGroups();
          this.updateLocalGroups();
          await this.getCurrentTeams();
          this.formGroups();
          await this.generateRounds();
          await this.generateRoundRobinSchedule();
        }
      }
    },
    sizeOfBrackets(val) {
      if (
        (this.type === "circuit" && this.teams.length >= 2) ||
        (this.type === "group" && this.teams.length >= 4 && val)
      ) {
        this.canSave = true;
      }
    },
    async countBy(val) {
      if (this.isVisible || this.visibilityBetweenStages) {
        this.countBy = val;
        this.matches = [];
        this.rounds = [];
        if (this.type === "circuit") {
          console.log("countby");
          await this.getCurrentTeams();
          await this.CircuitGenerate();
        }
      }
    },
    teams: {
      deep: true,
      async handler(n) {
        this.listedTeams = this.sortByStageStats(
          JSON.parse(JSON.stringify([...n])),
          true
        );
      }
    },
    partAccess: {
      handler(n) {
        if (n === true) {
          this.canSave = false;
        }
      }
    }
  }
};
</script>
<style scoped>
@import "./brackets.css";

.group-name-list {
  padding-left: 15px;
  font-size: 12px;
  margin-top: 10px;
}

.affix-header-style {
  position: relative;
  z-index: 99 !important;
}

.min-vh-90 {
  min-height: 90vh;
}

.page-title {
  border: 0;
}

.ttypes-radio-style.ivu-radio-wrapper {
  margin: 0 4px;
  width: 90px;
  height: 40px;
  padding: 5px 7px;
  background: #1e1f24;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  overflow: hidden;
  font-size: 13px;
  font-weight: bold;
  text-wrap: wrap;
  line-height: 1;
  text-align: center;
}

.ttypes-radio-style:hover {
  background: #2d3038;
}

.ttypes-radio-style :global(.ivu-radio) {
  display: none !important;
  position: absolute;
  top: -25px;
  left: -25px;
  transform: rotate(45deg);
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner) {
  border-radius: 0;
  width: 42px;
  height: 42px;
  background: #5abb73;
  border-color: #5abb73;
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner:after) {
  top: auto;
  left: auto;
  bottom: 15px;
  right: 2px;
  transform: rotate(0deg);
  width: 7px;
  height: 13px;
  border: 3px solid #ffffff;
  border-top: 0;
  border-left: 0;
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner:after) {
  border-radius: 0;
  background: none;
}

.ttypes-radio-style.ivu-radio-wrapper-checked {
  border: 1px solid #5abb73;
  box-shadow: 0 1px 6px rgba(90, 187, 115, 0.3);
}

.ttypes-radio-style.ivu-radio-wrapper-checked :global(.ivu-radio) {
  display: inline-block !important;
}

.brackets-sidebar-team-style span {
  font-size: 13px;
}

.standings .standing {
  display: flex;
  justify-content: space-between;
}

.standings .standing .r,
.standings .standing .n,
.standings .standing .w,
.standings .standing .l,
.standings .standing .diff,
.standings .standing-labels span {
  display: inline-block;
}

.standings .standing-labels {
  padding-right: 4px;
}

.panel.type-r {
  position: absolute;
  left: 0;
  padding-top: 55px;
}

.shuffle-button-style {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  font-size: 20px;
  line-height: 1;
  box-shadow: 0 1px 6px rgba(45, 183, 245, 0.3);
}

.shuffle-button-style:hover {
  box-shadow: 0 1px 6px rgba(45, 183, 245, 0.7);
}

.setting .setting-name {
  position: relative;
}

.info-hover {
  position: absolute;
  right: -22px;
  left: inherit;
  width: fit-content;
}

.info-hover1 {
  right: 8%;
}

@media only screen and (max-width: 959px) {
  .panel.type-r {
    padding-top: 0;
  }

  .bracket-custom-style .editor .panel .panel-content {
    top: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/brackets/BracketsSidebar.vue